/**
 * Dashboard reducer  file
 *
 * @package    src/services
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly
 */
import { ActionConstant } from '../constants'

/**
 * Initialize dashboard personal data state
 */
const initialState = {
  personalData : {
    first_name: '',
    last_name: '',
    phone_number: '',
    country: '',
    linkedin_url: '',
    recent_employer: '',
    recent_position: '',
    resume_path: '',
    job_names: '',
    job_levels:'',
    skill_names: '',
    skill_levels: ''
  },
  rate_config: null,
  rate_config_date: null,
  openAvailability: false,
  availability: {}
}

/**
 * Update store with new states among the dashboard actions
 */
export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case ActionConstant.GET_DEFAULT_PERSONAL_INFOS:
      return {
        ...state,
        action: action.type,
        personalData: action.datas,
      };
    case ActionConstant.UPDATE_CURRENCY_RATE_CONFIG:
      return {
        ...state,
        rate_config: action.payload.rate_config,
        rate_config_date: action.payload.rate_config_date
      };
    case ActionConstant.SHOW_AVAILABILITY_MODAL:
      return {
        ...state,
        openAvailability: action.payload
      };
    case ActionConstant.SAVE_AVAILABILITY_TO_STORE: {
      return {
        ...state,
        availability: action.payload
      }
    }
    default:
      return state;
  }
}
